module.exports = __webpack_public_path__ + "static/mouse-left.7d97dadf921ac27b9d8c2e791df8bb70.svg";